import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

interface IUnlockChoiceEligibilityContext {
    propertyId?: number | null;
    offerId?: number | null;
}

export const isUnlockChoiceEligible = (entryPoint: UnlockChoiceEntryPoint, {propertyId, offerId}: IUnlockChoiceEligibilityContext): boolean =>
    entryPoint === UnlockChoiceEntryPoint.PRICE ? Boolean(propertyId) : Boolean(offerId);
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

interface IUnlockChoiceEligibilityContext {
    propertyId?: number | null;
    offerId?: number | null;
}

export const isUnlockChoiceEligible = (entryPoint: UnlockChoiceEntryPoint, {propertyId, offerId}: IUnlockChoiceEligibilityContext): boolean =>
    entryPoint === UnlockChoiceEntryPoint.PRICE ? Boolean(propertyId) : Boolean(offerId);
